import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { errMsg } from "../../lib/format";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { Label } from "../../components/ui/label";
import { Switch } from "../../components/ui/switch";
import { useAuth } from "../../context/AuthContext";

export default function AdminSettings() {
  const { user } = useAuth();
  const [s, setS] = useState(null);

  useEffect(() => { api.get("/admin/settings").then((r) => setS(r.data)); }, []);

  const save = async () => {
    try {
      const { data } = await api.patch("/admin/settings", s);
      setS(data);
      toast.success("Settings saved");
    } catch (err) { toast.error(errMsg(err.response?.data?.detail)); }
  };

  if (!s) return null;

  return (
    <div>
      <p className="overline">Configuration</p>
      <h1 className="font-heading font-extrabold text-3xl tracking-tight mt-1 mb-8">System Settings</h1>

      <div className="grid lg:grid-cols-2 gap-6 max-w-4xl">
        <div className="bg-card border border-border rounded-sm p-6 space-y-4">
          <h2 className="font-heading font-bold text-lg">General</h2>
          <div><Label className="overline">Site Name</Label><Input data-testid="settings-site-name" value={s.site_name || ""} onChange={(e) => setS({ ...s, site_name: e.target.value })} className="mt-2 rounded-sm h-11" /></div>
          <div><Label className="overline">Support Email</Label><Input data-testid="settings-support-email" value={s.support_email || ""} onChange={(e) => setS({ ...s, support_email: e.target.value })} className="mt-2 rounded-sm h-11" /></div>
          <div className="flex items-center justify-between border border-border rounded-sm px-4 py-3">
            <div><p className="text-sm font-medium">Maintenance Mode</p><p className="text-xs text-muted-foreground">Temporarily disable user actions</p></div>
            <Switch data-testid="settings-maintenance" checked={!!s.maintenance} onCheckedChange={(v) => setS({ ...s, maintenance: v })} />
          </div>
        </div>

        <div className="bg-card border border-border rounded-sm p-6 space-y-4">
          <h2 className="font-heading font-bold text-lg">Default Limits (₹)</h2>
          <div><Label className="overline">Default Min Deposit</Label><Input data-testid="settings-min-deposit" type="number" value={s.default_min_deposit || 0} onChange={(e) => setS({ ...s, default_min_deposit: Number(e.target.value) })} className="mt-2 rounded-sm h-11 font-mono-num" /></div>
          <div><Label className="overline">Default Max Deposit</Label><Input data-testid="settings-max-deposit" type="number" value={s.default_max_deposit || 0} onChange={(e) => setS({ ...s, default_max_deposit: Number(e.target.value) })} className="mt-2 rounded-sm h-11 font-mono-num" /></div>
          <div className="pt-4 border-t border-border/40">
            <p className="overline mb-1">Admin Account</p>
            <p className="text-sm">{user?.name}</p>
            <p className="font-mono-num text-xs text-muted-foreground">{user?.email}</p>
          </div>
        </div>
      </div>

      <Button data-testid="settings-save" onClick={save} className="rounded-sm h-11 mt-6">Save Settings</Button>
    </div>
  );
}
